export enum TicketActionType {
  SetState = 'TICKET.SET_STATE',
  GET_TICKETS = 'TICKET.GET_TICKETS',
  GET_TICKET = 'TICKET.GET_TICKET',
  CREATE_TICKET = 'TICKET.CREATE_TICKET',
  SEND_MESS_TICKET = 'TICKET.SEND_MESS_TICKET',
}
